import State from './State';

/**
 * Mutations are a synchronous way of modifying state. They are generally
 * called through Actions. It's best to think of them as setters.
 *
 * @see https://vuex.vuejs.org/guide/mutations.html
 *
 * @class Mutations
 * @package Store
 * @project ChalkySticks
 */
const mutations = {
	/**
	 * @param State state
	 * @param any payload
	 * @return void
	 */
	example(state: typeof State, payload: any): void {
		state.foo = 'boo';
	},

	/**
	 * @param State state
	 * @param any payload
	 * @return void
	 */
	setQueryParameters(state: typeof State, payload: any): void {
		state.queryParameters = payload;
	},
};

export default mutations;
